export interface Review {
  id: number;
  username: string;
  avatar: string;
  role: string;
  rating: number;
  title: string;
  content: string;
}

export const reviews: Review[] = [
  {
    id: 1,
    username: '吃瓜群众小王',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20person%20avatar%20cartoon%20style%2C%20warm%20friendly%20expression%2C%20simple%20clean%20background%2C%20minimalist%20illustration&width=80&height=80&seq=avatar-01&orientation=squarish',
    role: '忠实瓜友 · 3年',
    rating: 5,
    title: '全网吃瓜第一站！',
    content: '自从发现了吃瓜网，再也不用到处找八卦了。每天打开就能看到最新的娱乐圈动态，关键是更新速度真的快，很多消息都是首发！',
  },
  {
    id: 2,
    username: '八卦研究员',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20person%20avatar%20cartoon%20style%2C%20curious%20expression%2C%20simple%20clean%20background%2C%20minimalist%20illustration&width=80&height=80&seq=avatar-02&orientation=squarish',
    role: '资深吃瓜人 · 5年',
    rating: 5,
    title: '黑料区太敢说了！',
    content: '黑料曝光区的内容真的让人大开眼界，很多在其他平台看不到的内幕这里都有。小编的爆料速度和深度都是一流的。',
  },
  {
    id: 3,
    username: '娱乐圈观察家',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20person%20avatar%20cartoon%20style%2C%20professional%20expression%2C%20simple%20clean%20background%2C%20minimalist%20illustration&width=80&height=80&seq=avatar-03&orientation=squarish',
    role: '娱乐博主 · 2年',
    rating: 5,
    title: '每日必刷的网站',
    content: '作为一个娱乐博主，吃瓜网是我每天必刷的信息来源。内容真实度高，分类清晰，查找起来特别方便，强烈推荐给爱吃瓜的朋友们！',
  },
  {
    id: 4,
    username: '深夜吃瓜人',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20person%20avatar%20cartoon%20style%2C%20night%20owl%20expression%2C%20simple%20clean%20background%2C%20minimalist%20illustration&width=80&height=80&seq=avatar-04&orientation=squarish',
    role: '夜猫子瓜友 · 1年',
    rating: 4,
    title: '视频区干货满满',
    content: '视频吃瓜区的内容特别精彩，很多现场直击的视频在其他平台根本看不到。每天晚上刷一刷，解压又过瘾！',
  },
  {
    id: 5,
    username: '追瓜一线',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20person%20avatar%20cartoon%20style%2C%20excited%20expression%2C%20simple%20clean%20background%2C%20minimalist%20illustration&width=80&height=80&seq=avatar-05&orientation=squarish',
    role: '资深瓜友 · 4年',
    rating: 5,
    title: '塌房最快的消息源',
    content: '每次网红塌房，吃瓜网都是最先报道的！我已经安利给身边所有爱吃瓜的朋友了，真的是一入吃瓜深似海。',
  },
  {
    id: 6,
    username: '理性吃瓜群众',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20person%20avatar%20cartoon%20style%2C%20calm%20expression%2C%20simple%20clean%20background%2C%20minimalist%20illustration&width=80&height=80&seq=avatar-06&orientation=squarish',
    role: '新瓜友 · 6个月',
    rating: 4,
    title: '界面清爽无广告',
    content: '比起其他八卦网站满天飞的广告，吃瓜网的界面真的很清爽，阅读体验特别好。内容质量也很高，会继续支持的！',
  },
];

export const aboutReviews = reviews;